import APIServiceLookUp from './serviceAPI';
import { MAIN_API_URL } from './models/AppConstent';

export default class ServiceFloor {
    lookupService = new APIServiceLookUp();

    async printOrder(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}print/printOrder`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async printBill(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}print/printBill`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async printBooking(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}print/printBooking`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async printHostelBooking(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}print/printHostelBooking`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }
}